module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "view-users-container"
    }
  }, [_c('div', {
    attrs: {
      "id": "view-users"
    }
  }, [_c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "columns users-toolbar"
  }, [_c('div', {
    staticClass: "column is-10"
  }, [_c('p', {
    staticClass: "control has-icon search-container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchString),
      expression: "searchString"
    }],
    staticClass: "input is-medium",
    attrs: {
      "type": "text",
      "placeholder": "Procurar Utilizadores"
    },
    domProps: {
      "value": (_vm.searchString)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchString = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-2"
  }, [_c('user-new')], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "container is-fluid"
  }, [_c('div', {
    staticClass: "flexbox-grid"
  }, _vm._l((_vm.users), function(user) {
    return _c('user-card', {
      attrs: {
        "user": user
      }
    })
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7f4ae910!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/index.vue
// module id = 339
// module chunks = 1